import { useDevLogger } from '../dev-logger/index.ts'
import { NAME } from './consts.js'

export const logger = useDevLogger(NAME)
